import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const NoAccessPage: React.FC = () => {
  const { t: generalT } = useTranslation("general");

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      minHeight={"400px"}
    >
      <Typography
        component={"h2"}
        textAlign={"center"}
        fontSize={{ xs: "14px", md: "16px" }}
      >
        {generalT("youHaveNoAccessToPage")}
      </Typography>
    </Box>
  );
};

export default NoAccessPage;
